import axios from 'axios'
// import {Message, MessageBox} from 'element-ui'
import store from '../store'
import qs from 'qs';
// import {changeJson,SStorage} from './auth';

/**
 * Axios遇到自签名服务后台的解决方案
 * https://new.qq.com/omn/20180205/20180205G07IPG.html
 */
var https = require('https')
var httpAdapter = require('axios/lib/adapters/http');
// 创建axios实例
const service = axios.create({
  baseURL: window.g.url, // api的base_url
  timeout: 10000,                  // 请求超时时间2
  headers: {
    // 'content-type': 'application/x-www-form-urlencoded',
    'Access-Control-Allow-Origin': '*', 
    'content-type': 'application/json',
  },
  adapter: httpAdapter,
})
// request拦截器
service.interceptors.request.use(config => {
  // console.log(SStorage.getItem('user'))
  config.headers['token'] = sessionStorage.getItem('token');// 增加请求头 token参数
  return config
}, error => {
  // Do something with request error
  console.error(error) // for debug
  Promise.reject(error)
})
// respone拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    // if (res.returnCode == '1000') {
      return res;
    // }
    // if (res.returnCode == '100') {
    //   return res.returnData;
    // } else if (res.returnCode == "20011") {
    //   Message({
    //     showClose: true,
    //     message: res.returnMsg,
    //     type: 'error',
    //     duration: 500,
    //     onClose: () => {
    //       store.dispatch('FedLogOut').then(() => {
    //         location.reload()// 为了重新实例化vue-router对象 避免bug
    //       })
    //     }
    //   });
    //   return Promise.reject("未登录")
    // } else {
      // Message({
      //   message: res.returnMsg,
      //   type: 'error',
      //   duration: 3 * 1000
      // })
      // return Promise.reject(res)
    // }
  },
  error => {
    console.error('err' + error)// for debug
    // Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    return Promise.reject(error)
  }
)
// export default service

export const api = params => {
  // return service.post(window.g.url+'/'+params.method,  qs.stringify(params.obj)).then(res => res);
  return service.post(window.g.url+'/'+params.method,  params.obj).then(res => res);
};


// 错误响应
export const errMethod = params => {
  
  
};



// WEBPACK FOOTER //
// ./src/utils/api.js